import { render, staticRenderFns } from "./Assign-clean-score.vue?vue&type=template&id=51ac9d5f&scoped=true&"
import script from "./Assign-clean-score.vue?vue&type=script&lang=js&"
export * from "./Assign-clean-score.vue?vue&type=script&lang=js&"
import style0 from "./Assign-clean-score.vue?vue&type=style&index=0&id=51ac9d5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ac9d5f",
  null
  
)

export default component.exports